var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import useNavigateWithLocationCheck from '@/hooks/useNavigateWithLocationCheck';
import useNavigation from '@/navigation/useNavigation';
import { useCheckAuth } from '@/utils/checkAuth';
import PlaceDetailPlaceToiletReviewItem from '../../PlaceDetailScreen/components/PlaceToiletReviewItem';
import { EmptyStateCard } from '../components/AccessibilityInfoComponents';
export default function V2RestroomTab({ toiletReviews, placeId, placeName, placeLocation, placeAddress, isAccessibilityRegistrable: _isAccessibilityRegistrable, }) {
    const navigation = useNavigation();
    const checkAuth = useCheckAuth();
    const { navigateWithLocationCheck, LocationConfirmModal } = useNavigateWithLocationCheck();
    const handleToiletReviewPress = () => {
        checkAuth(() => __awaiter(this, void 0, void 0, function* () {
            yield navigateWithLocationCheck({
                targetLocation: placeLocation,
                placeName: placeName,
                address: placeAddress,
                type: 'place',
                onNavigate: () => {
                    navigation.navigate('ReviewForm/Toilet', {
                        placeId,
                    });
                },
            });
        }), undefined, '앱에서 화장실 정보를 등록해보세요');
    };
    if (toiletReviews.length === 0) {
        return (_jsxs(EmptyStateWrapper, { children: [_jsx(EmptyStateCard, { title: '등록된 장애인 화장실 정보가 없어요🥲', description: '장애인 화장실을 등록해주시면 큰 도움이 됩니다.', buttonText: "\uC7A5\uC560\uC778 \uD654\uC7A5\uC2E4 \uC815\uBCF4 \uB4F1\uB85D", onPress: handleToiletReviewPress, elementName: "place_detail_restroom_tab_empty_register" }), LocationConfirmModal] }));
    }
    return (_jsxs(Container, { children: [_jsx(SectionContainer, { children: _jsx(ItemList, { children: toiletReviews.map((review, idx) => (_jsxs(React.Fragment, { children: [_jsx(PlaceDetailPlaceToiletReviewItem, { placeId: placeId, review: review }), idx !== toiletReviews.length - 1 && _jsx(Divider, {})] }, review.id))) }) }), LocationConfirmModal] }));
}
const Container = styled.View `
  background-color: ${color.white};
`;
const SectionContainer = styled.View `
  padding-vertical: 32px;
  padding-horizontal: 20px;
  gap: 20px;
`;
const EmptyStateWrapper = styled.View `
  flex: 1;
  background-color: ${color.gray5};
  padding-top: 20px;
`;
const ItemList = styled.View `
  flex-direction: column;
  gap: 20px;
`;
const Divider = styled.View `
  height: 1px;
  background-color: ${color.gray20};
`;
